import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  async function fazerLogin(e) {
    e.preventDefault();

    try {
      setLoading(true);

      const res = await fetch("https://zoomimpressaodigital.com.br/pontozoom/api/login.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email,
          senha
        })
      });

      if (!res.ok) throw new Error();

      const user = await res.json();

      // salva usuário logado
      localStorage.setItem("usuario", JSON.stringify(user));

      navigate("/");

    } catch {
      alert("Email ou senha inválidos");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-container">

      <div className="login-header">
        <div className="logo">
          <span className="logo-icon">📍</span>
          <h1 className="logo-text">Ponto<span className="logo-highlight">Zoom</span></h1>
        </div>
        <p className="tagline">Controle de ponto inteligente</p>
      </div>

      <form onSubmit={fazerLogin} className="login-box">

        <div className="form-header">
          <h2 className="form-title">Acesse sua conta</h2>
          <p className="form-subtitle">Entre com suas credenciais</p>
        </div>

        <div className="input-group">
          <div className="input-icon">✉️</div>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="login-input"
            required
            disabled={loading}
          />
        </div>

        <div className="input-group">
          <div className="input-icon">🔒</div>
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            className="login-input"
            required
            disabled={loading}
          />
          <button 
            type="button" 
            className="password-toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "🙈" : "👁️"}
          </button>
        </div>

        <button type="submit" className="login-button" disabled={loading}>
          {loading ? (
            <>
              <span className="loading-spinner"></span>
              Entrando...
            </>
          ) : (
            <>
              <span className="button-icon">🚀</span>
              Entrar
            </>
          )}
        </button>

   

      </form>


      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .login-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
          color: #fff;
          font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 20px;
          position: relative;
          overflow: hidden;
        }

        .login-container::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(90deg, 
            transparent, 
            rgba(255, 107, 0, 0.5), 
            transparent
          );
        }

        .login-header {
          text-align: center;
          margin-bottom: 40px;
          z-index: 1;
        }

        .logo {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-bottom: 10px;
        }

        .logo-icon {
          font-size: 2.5rem;
          animation: pulse 2s infinite;
        }

        .logo-text {
          font-size: 2.8rem;
          background: linear-gradient(45deg, #fff, #FF8C42);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-weight: 800;
          letter-spacing: -0.5px;
        }

        .logo-highlight {
          background: linear-gradient(45deg, #FF6B00, #FFA726);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .tagline {
          color: #888;
          font-size: 1rem;
          font-weight: 400;
          letter-spacing: 1px;
        }

        .login-box {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          padding: 40px;
          width: 100%;
          max-width: 420px;
          border: 1px solid rgba(255, 140, 66, 0.2);
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5);
          z-index: 1;
          margin-bottom: 40px;
        }

        .form-header {
          text-align: center;
          margin-bottom: 30px;
        }

        .form-title {
          font-size: 1.8rem;
          color: #FF8C42;
          margin-bottom: 8px;
          font-weight: 600;
        }

        .form-subtitle {
          color: #888;
          font-size: 0.95rem;
        }

        .input-group {
          position: relative;
          margin-bottom: 20px;
        }

        .input-icon {
          position: absolute;
          left: 15px;
          top: 50%;
          transform: translateY(-50%);
          color: #FF8C42;
          font-size: 1.2rem;
          z-index: 1;
        }

        .login-input {
          width: 100%;
          padding: 16px 16px 16px 45px;
          background: rgba(255, 255, 255, 0.08);
          border: 1px solid rgba(255, 140, 66, 0.2);
          border-radius: 12px;
          color: #fff;
          font-size: 1rem;
          transition: all 0.3s ease;
        }

        .login-input:focus {
          outline: none;
          border-color: rgba(255, 140, 66, 0.5);
          box-shadow: 0 0 0 3px rgba(255, 107, 0, 0.2);
          background: rgba(255, 255, 255, 0.12);
        }

        .login-input::placeholder {
          color: #888;
        }

        .login-input:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .password-toggle {
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          background: transparent;
          border: none;
          color: #FF8C42;
          font-size: 1.2rem;
          cursor: pointer;
          padding: 5px;
          border-radius: 4px;
          transition: all 0.2s ease;
        }

        .password-toggle:hover {
          background: rgba(255, 140, 66, 0.1);
        }

        .login-button {
          width: 100%;
          padding: 16px;
          background: linear-gradient(135deg, #FF6B00, #FF8C42);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-top: 10px;
          box-shadow: 0 4px 15px rgba(255, 107, 0, 0.3);
        }

        .login-button:hover:not(:disabled) {
          background: linear-gradient(135deg, #FF8C42, #FF6B00);
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(255, 107, 0, 0.4);
        }

        .login-button:active:not(:disabled) {
          transform: translateY(0);
        }

        .login-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .button-icon {
          font-size: 1.2rem;
        }

        .loading-spinner {
          width: 18px;
          height: 18px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top: 2px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .login-footer {
          margin-top: 25px;
          text-align: center;
          padding-top: 20px;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }

        .help-text {
          color: #888;
          font-size: 0.9rem;
          margin-bottom: 10px;
        }

        .help-link {
          color: #FF8C42;
          text-decoration: none;
          transition: all 0.2s ease;
        }

        .help-link:hover {
          color: #FF6B00;
          text-decoration: underline;
        }

        .version {
          color: #666;
          font-size: 0.8rem;
          font-style: italic;
        }

        .features {
          display: flex;
          justify-content: center;
          gap: 30px;
          flex-wrap: wrap;
          max-width: 800px;
          z-index: 1;
        }

        .feature {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 15px 20px;
          background: rgba(255, 255, 255, 0.03);
          border-radius: 12px;
          border: 1px solid rgba(255, 140, 66, 0.1);
          transition: all 0.3s ease;
        }

        .feature:hover {
          background: rgba(255, 255, 255, 0.08);
          transform: translateY(-2px);
          border-color: rgba(255, 140, 66, 0.3);
        }

        .feature-icon {
          font-size: 1.5rem;
          color: #FF8C42;
        }

        .feature-text {
          color: #ccc;
          font-size: 0.9rem;
          font-weight: 500;
        }

        /* Animações */
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* Responsividade */
        @media (max-width: 480px) {
          .login-container {
            padding: 15px;
          }
          
          .login-box {
            padding: 30px 20px;
          }
          
          .logo-text {
            font-size: 2.2rem;
          }
          
          .tagline {
            font-size: 0.9rem;
          }
          
          .features {
            flex-direction: column;
            align-items: center;
            gap: 15px;
          }
          
          .feature {
            width: 100%;
            max-width: 280px;
            justify-content: center;
          }
        }

        /* Efeitos de partículas (opcional) */
        .particle {
          position: absolute;
          width: 2px;
          height: 2px;
          background: rgba(255, 107, 0, 0.3);
          border-radius: 50%;
          animation: float 15s infinite linear;
        }

        @keyframes float {
          0% {
            transform: translateY(100vh) translateX(0);
          }
          100% {
            transform: translateY(-100vh) translateX(100px);
          }
        }

        /* Geração de partículas via JS pode ser adicionada se desejar */
      `}</style>

      {/* Partículas decorativas */}
      {Array.from({ length: 15 }).map((_, i) => (
        <div
          key={i}
          className="particle"
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 5}s`,
            animationDuration: `${15 + Math.random() * 10}s`,
            opacity: Math.random() * 0.5 + 0.2,
          }}
        />
      ))}

    </div>
  );
}